import React from "react";
import TopbarContent from "./TopbarContent";

const Topbar = ({ toggleSidebar }) => {
    return <TopbarContent toggleSidebar={toggleSidebar} />;
};

export default Topbar;
